export const meta: BlockMeta = {
  title: "Accordion List Item",
  description: "A single accordion list item",
  keywords: ["downloads", "files", "content"],
  icon: "book-alt",
  category: "layouts",
}

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@components/controls/Accordion"
import { defineBlock, EditableText, useInlineEditableValue } from "eddev/blocks"
import { useContext } from "react"
import { tv } from "tailwind-variants"
import { AccordionListContext } from "./accordion-list"

const variants = tv({
  base: "[&_.accordion-content-indicator]:!type-title-xs-medium [&_.accordion-content-indicator]:!mr-2 [&_.accordion-content-inner]:!mt-0",
  variants: {
    admin: {
      true: "",
    },
  },
  defaultVariants: {
    admin: false,
  },
})

export default defineBlock("content/accordion-list-item", (props) => {
  const { activeItem, setActiveItem } = useContext(AccordionListContext)
  const [title] = useInlineEditableValue<string>("title")

  return (
    <div className={variants({ admin: env.admin })}>
      <Accordion type="single" value={activeItem} onValueChange={(item) => setActiveItem(item)}>
        <AccordionItem value={title} className="my-1">
          <AccordionTrigger>
            <EditableText
              as="p"
              className="!type-title-xs-medium"
              store="title"
              inlineToolbar={false}
              defaultValue="Example title"
              placeholder="Example title"
            />
          </AccordionTrigger>
          <AccordionContent>
            <EditableText
              as="p"
              className="!type-body-m-serif"
              store="content"
              inlineToolbar={true}
              defaultValue="Example content"
              placeholder="Example content"
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
})
